// extracted by mini-css-extract-plugin
module.exports = {"actionButtonsContainer":"ReferralSources_actionButtonsContainer__2BHey","actionColumn":"ReferralSources_actionColumn__1bMFj","textButton":"ReferralSources_textButton__yenHn"};